import { render, staticRenderFns } from "./ReserveButton.vue?vue&type=template&id=2cd958b4&"
import script from "./ReserveButton.vue?vue&type=script&lang=js&"
export * from "./ReserveButton.vue?vue&type=script&lang=js&"
import style0 from "./ReserveButton.vue?vue&type=style&index=0&id=2cd958b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VListItemContent,VRow,VSelect})
